export const SocketMessageType = {
	// Notifications
	NOTIFICATION_CREATED: 'notificationAdded',
	MARK_NOTIFICATION_READ: 'markNotificationRead',
	MARK_NOTIFICATION_UNREAD: 'markNotificationUnread',
	MARK_ALL_NOTIFICATIONS_READ: 'markAllNotificationsRead',

	// Time entries
	TIME_TRACKER_STARTED: 'startTimeTracker',
	TIME_TRACKER_PAUSED: 'pauseTimeTracker',
	TIME_TRACKER_COMPLETED: 'completeTimeTracker',
	TIME_ENTRY_CREATED: 'timeEntryCreated',
	TIME_ENTRY_UPDATED: 'timeEntryModified',
	TIME_ENTRY_DELETED: 'timeEntryDeleted',

	// Tasks
	TASK_CREATED: 'newTaskAdded',
	TASK_UPDATED: 'taskChanged',
	TASK_SET_DONE: 'taskSetDone',

	// Trial
	TRIAL_PROGRESS_CHANGED: 'trialProgressChanged',
	TRIAL_PROGRESS_SITE_READY: 'siteReady',

	// Events
	EVENT_CREATED: 'newEventAdded',
	EVENT_UPDATED: 'eventChanged',
	EVENT_DELETED: 'eventDeleted',

	// Eli
	ELI_CHAT_THREAD_CREATED: 'eliChatThreadCreated',
	ELI_CHAT_THREAD_UPDATED: 'eliChatThreadUpdated',
	ELI_CHAT_CURRENT_ACTION: 'eliChatCurrentAction',
	ELI_CHAT_MESSAGE_SUCCESS: 'eliChatMessageSuccess',
	ELI_CHAT_MESSAGE_FAILED: 'eliChatMessageFailed',
	ELI_CHAT_ACTION_THINKING: 'eliChatThinking',

	// Bookings
	BOOKING_CREATED: 'bookingCreated',
	BOOKING_UPDATED: 'bookingUpdated',
	BOOKINGS_DELETED: 'bookingsDeleted',

	// Project
	PROJECT_MEMBERS_CHANGED: 'projectMembersChanged',
	PROJECT_TIMEFRAME_CHANGED: 'projectTimeframeChanged',
	PROJECT_CHANGED: 'projectChanged',
	PROJECT_CACHE_CHANGED: 'projectCacheChanged',
	PROJECT_HEALTH_SCORE_CHANGED: 'projectHealthScoreChanged',

	// Project phases
	NEW_PHASE_ADDED: 'newPhaseAdded',
	PHASE_CHANGED: 'phaseChanged',
	PHASE_DELETED: 'phaseDeleted',

	// Time Off
	TIME_OFF_UPDATED: 'timeOffUpdated',
	TIME_OFF_DELETED: 'timeOffDeleted',
} as const;
